package system.single

import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.github.quillraven.fleks.World.Companion.inject
import component.*
import org.jbox2d.dynamics.World

class CoinCollectionSystem(
    private val physicWorld: World = inject()
): IteratingSystem( family{all(CoinComponent)}) {

    private var timeAccumulator = 0f

    override fun onTick() {
        if (timeAccumulator < 0.25f) {
            timeAccumulator += deltaTime
            return
        }

        timeAccumulator = 0f

        super.onTick()
    }

    override fun onTickEntity(entity: Entity) {
        val coinComp = entity[CoinComponent]
        if (coinComp.isCollected) {
            coinComp.view.removeFromParent()
            coinComp.body.userData = null
            physicWorld.destroyBody(coinComp.body)
            entity.remove()
        }
    }
}
